<template>
    <div>
        <el-row :gutter="30">
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="imgPath" label="图片:" :rules="[{ required: true, message: '请上传图片' }]">
                    <image-upload v-if="formData.type == 4" :url.sync="formData.imgPath"
                        :urlFull.sync="formData.imgPath"
                        accept="image/png, image/jpeg, image/jpg, image/gif, image/svga" crop :width="670"
                        :height="130"></image-upload>
					<image-upload v-else-if="formData.type == 10" :url.sync="formData.imgPath"
					    :urlFull.sync="formData.imgPath"
					    accept="image/png, image/jpeg, image/jpg, image/gif, image/svga" crop :width="670"
					    :height="120"></image-upload>
					<image-upload v-else-if="formData.type == 11" :url.sync="formData.imgPath"
						:urlFull.sync="formData.imgPath"
						accept="image/png, image/jpeg, image/jpg, image/gif, image/svga" crop :width="1114"
						:height="200"></image-upload>
                    <image-upload v-else :url.sync="formData.imgPath" :urlFull.sync="formData.imgPath"
                        accept="image/png, image/jpeg, image/jpg, image/gif, image/svga" crop :width="1035"
                        :height="165"></image-upload>
                </el-form-item>
				<el-form-item prop="cityType" label="">
					<span slot="label">
						展示城市:
						<el-radio-group v-model="formData.cityType">
							<el-radio :label="0">全国展示</el-radio>
							<el-radio :label="1">只在下面地区展示</el-radio>
							<!-- <el-radio :label="2"><span style="color:#F56C6C">不在</span>下面地区展示</el-radio> -->
						</el-radio-group>
					</span>
				</el-form-item>
				<el-form-item prop="sellArea" style="margin-top: -22px;">
				    <span slot="label">地区设置:</span>
				    <el-cascader v-model="formData.cityCodeAndNameVos" :options="cityList" filterable
				        :props="{ label: 'name', children: 'cityList', value: 'id', multiple: true, checkStrictly: true }"
				        style="width:100%" ref="cityCascader" :disabled="formData.cityType != 0 ? false : true">
				    </el-cascader>
					<small class="MT10 color-danger">					   
						如果同时设置了省份和省份下的某个城市展示，则全省展示。如果同时设置了省份和省份下的某个城市不展示，则全省不展示。
					</small>
				</el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="time1" label="展示时间段1:" :rules="[{ required: true, message: '请设置展示时间段1' }]">
                    <span slot="label">展示时间段1：</span>
                    <el-date-picker v-model="formData.time1" type="datetimerange" range-separator="至"
                        value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']"
                        start-placeholder="开始时间" end-placeholder="结束时间" unlink-panels>
                    </el-date-picker>
                </el-form-item>
				<el-form-item prop="time2" label="展示时间段2:">
				    <span slot="label">展示时间段2：</span>
				    <el-date-picker v-model="formData.time2" type="datetimerange" range-separator="至"
				        value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']"
				        start-placeholder="开始时间" end-placeholder="结束时间" unlink-panels>
				    </el-date-picker>
				</el-form-item>
				<el-form-item prop="time3" label="展示时间段3:">
				    <span slot="label">
						展示时间段3：
						<small><span class="el-icon-warning"></span>  最晚的展示时间段到期后，会自动隐藏广告。</small>
					</span>
				    <el-date-picker v-model="formData.time3" type="datetimerange" range-separator="至"
				        value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']"
				        start-placeholder="开始时间" end-placeholder="结束时间" unlink-panels>
				    </el-date-picker>
					<!-- <small class="MT10 color-danger">
					    最晚的展示时间段到期后，会自动隐藏广告。
					</small> -->
				</el-form-item>
                <el-form-item prop="link" label="跳转链接:">
                    <el-input placeholder="请填写跳转链接" v-model="formData.link" maxlength="200"></el-input>
                </el-form-item>
                <el-form-item v-if="formData.type == 5 || formData.type == 10" prop="showUserType" label="用户身份:">
                    <el-select v-model="formData.showUserType" placeholder="请选择">
                        <el-option label="对所有用户展示该广告" :value="0"></el-option>
                        <el-option label="仅对乐迷展示该广告" :value="1"></el-option>
                        <el-option label="仅对艺人展示该广告" :value="2"></el-option>
                        <el-option label="仅对场地展示该广告" :value="3"></el-option>
                        <el-option label="仅对厂牌展示该广告" :value="5"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
        </el-row>
		<el-row :gutter="30">
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="aliLink" label="支付宝小程序跳转地址:">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="8">
                            <el-input placeholder="支付宝小程序APPID" v-model="formData.aliLinkAppid" maxlength="50"></el-input>
                        </el-col>
                        <el-col :xs="24" :sm="16">
                            <el-input placeholder="支付宝小程序跳转路径" v-model="formData.aliLink" maxlength="200"></el-input>
                        </el-col>
                    </el-row>
                    <small class="MT10 color-danger">
                        注意：跳转到外部小程序，这里填写好信息以后，可能还需要对方小程序添加白名单，请联系对方小程序负责人
                    </small>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :xl="8">
                <el-form-item prop="wxLink" label="微信小程序跳转地址:">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="8">
                            <el-input placeholder="微信小程序APPID" v-model="formData.wxLinkAppid" maxlength="50"></el-input>
                        </el-col>
                        <el-col :xs="24" :sm="16">
                            <el-input placeholder="微信小程序跳转路径" v-model="formData.wxLink" maxlength="200"></el-input>
                        </el-col>
                    </el-row>
                    <small class="MT10 color-danger">
                        注意：跳转到外部小程序，这里填写好信息以后，可能还需要对方小程序添加白名单，请联系对方小程序负责人
                    </small>
                </el-form-item>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import ImageUpload from '@/components/ImageUpload';
import { fetchAllCity } from '@/assets/js/commonApi'
export default {
    components: { ImageUpload },
    props: {
        formData: {
            type: Object,
            default: null
        },
		cityOptions: {
		    type: Array,
		    default: () => []
		},
		
    },
    data() {
        return {			
			cityList:[]
        }
    },
	async created() {
		await this.getCityList();		
	},
    methods: {
		//获取城市列表
		async getCityList() {
		    const res = await fetchAllCity({}).catch(() => { });
		    const { state, result } = res.data;
		    if (state == 1) {
		        this.cityList = result;
		    }
		},
		
    }
}
</script>
<style lang="scss" scoped>
</style>